import { Button, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { AiFillLock, AiOutlineLock } from 'react-icons/ai'
import useTelemetryStore from 'store/robotTelemetry'

const RobotLocks = () => {
  const telemetry = useTelemetryStore(s => s.telemetry)
  const { t } = useTranslation()
  return (
    <Stack
      direction="row"
      bgcolor="info.main"
      borderRadius={2}
      gap={2}
      flexWrap={{ xs: 'wrap', sm: 'nowrap' }}
      marginBottom={0}
      justifyContent="space-between"
      padding={2}
    >
      <Typography variant="caption" color="secondary.main" display="flex" alignItems="center" marginRight={1}>
        {t('locks.locks')}
      </Typography>
      <Button
        variant={telemetry?.locks?.front ? 'contained' : 'outlined'}
        color="secondary"
        startIcon={telemetry?.locks?.front ? <AiFillLock /> : <AiOutlineLock />}
        fullWidth
      >
        {t('locks.front')}
      </Button>
      <Button
        variant={telemetry?.locks?.charge ? 'contained' : 'outlined'}
        color="secondary"
        startIcon={telemetry?.locks?.charge ? <AiFillLock /> : <AiOutlineLock />}
        fullWidth
      >
        {t('locks.charge')}
      </Button>
      <Button
        variant={telemetry?.locks?.body ? 'contained' : 'outlined'}
        color="secondary"
        startIcon={telemetry?.locks?.body ? <AiFillLock /> : <AiOutlineLock />}
        fullWidth
      >
        {t('locks.body')}
      </Button>
      <Button
        variant={telemetry?.locks?.trash ? 'contained' : 'outlined'}
        color="secondary"
        startIcon={telemetry?.locks?.trash ? <AiFillLock /> : <AiOutlineLock />}
        fullWidth
      >
        {t('locks.trash')}
      </Button>
    </Stack>
  )
}

export default RobotLocks
